import { FrontendComponentEnum } from '@rehau/shared/enums';
import { AbstractStatic } from '@rehau/shared/forms/elements/static';
import { ObjectIteratorInterface } from '@rehau/shared/objectIterator.interface';
import { FormStaticTypeEnum } from '@rehau/shared/enums/formStaticType.enum';

export class DescriptionStatic extends AbstractStatic {
  public text: string;

  public constructor(
    text: string,
    label: string | null = 'rehau.atHomeSetup.product_description.label',
    countryConfigMapping: ObjectIteratorInterface<string> = {}
  ) {
    super(
      FormStaticTypeEnum.DescriptionStatic,
      FrontendComponentEnum.SimpleDescriptionBox,
      label,
      countryConfigMapping
    );
    this.text = text;
  }
}
